export const ACCEPT_FAILED_MESSAGE = "Couldn't accept the terms. Please try again.";
export const SIGN_OUT_FAILED_MESSAGE = "Couldn't sign you out. Please try again.";
